/*
* Project: LegalPlace assistant
* File: src/components/buy/checkout.js
* Authors: Nasreddine DAIFALLAH, Moncef HAMMOU
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import LpHeader from './header';
import LpCart from './cart';
import { PackChoice } from './pack_choice';
import CePackChoiceOne from './ce-checkout-step-one';

import OptionsSelection from './options';
import PreviewModal from '../modal';

import { togglePreview } from '../../redux/actions/toggle_preview';
import lpevents from '../../tracking/lpevents';
import LpPayment from '../../logic/payment';
import LpMobilePayBar from './mobile_pay_bar';
import { scrollAndGoUp } from '../utils/misc';
import LpInvoice from './invoice';
import { lpPattern, P_CHECK_PREVIEW } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import { HARCODED_CHECKOUT_META_IDS } from '../../constants/hardcoded_checkout';
import CheckoutNew from './Checkout/CheckoutNew';

class _Packs extends Component {
  constructor(props) {
    super(props);
    this.toggleTheModel = this.toggleTheModel.bind(this);
  }

  componentWillMount() {
    if (typeof window.lp_payment === 'undefined') {
      window.lp_payment = new LpPayment();
    }
    // create
    //      this.sdbNotif.endInBlueNotification();
    const wizardContainer = document.getElementById('wizard-container');
    if (wizardContainer) {
      wizardContainer.classList.remove('wizard-container');
    }
    if (window.Intercom) {
      window.Intercom('update');
    }
  }

  componentDidMount() {
    if (HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1) {
      document.body.id = 'ce_v3';
    } else {
      document.body.id = 'page-checkout';
    }
    lpPattern.init();
    scrollAndGoUp();
    if (lpApp.contractMetaId && HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) === -1 && window.exectuteOnceCheckoutActe) {
      if (window.exectuteOnceCheckoutActe === 2)
      lpevents.trackGTMCheckoutStep(3, 'Récapitulatif de votre commande', lpApp.getState().contract, lpApp.getState().checkout_operations, lpApp.contractMetaId, ['Pack Basique', 'Pack Complet'])

      window.exectuteOnceCheckoutActe += 1
    }
    // Hiding partners
    // document.getElementsByClassName('partners-links')[0].style.display = 'none';
  }

  componentWillUpdate() {
    if (this.props.doc_state === '') {
      this.props.setContinue(this.props.doc_state);
    }
  }

  componentWillUnmount() {
    // Hiding partners
    // document.getElementsByClassName('partners-links')[0].style.display = 'block';

    const wizardContainer = document.getElementById('wizard-container');
    if (wizardContainer) {
      wizardContainer.classList.add('wizard-container');
    }
  }

  toggleTheModel() {
    this.props.showTheModal();
    lpevents.track('Preview checkout');
    lpPattern.trackInPayment(P_CHECK_PREVIEW);
  }

  render() {
    const customCheckoutCta = lpApp.references.customs.custom ? lpApp.references.customs.custom.checkout_cta : '';
    // Define which checkout Coursier to display, depending if AB test is activated.
    return (
      <div className="lp-checkout">
        <LpHeader />
        {HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 ? (
          <CePackChoiceOne />
        ) : (
          <div className="container checkout-container">
            <div className="cc-main">
              {lpApp.contractMetaId === 302 ? (
                <CheckoutNew />
              ) : (
                <PackChoice />
              )}

              {this.props.disable_options && <OptionsSelection />}

              {this.props.pack_content && (
                <section className="page-section hidden-xs" id="checkout-recap">
                  <h2 className="section-title">
                    {_lp("Votre commande contient")}
                  </h2>
                  <div className="cr-container">
                    <h3>{this.props.title}</h3>
                    <div className="row">
                      <div className="col-sm-6">
                        <ul>
                          <li className="cr-pdf">
                            <a href="#" onClick={this.toggleTheModel}>
                              <i className="icn-pdf ic-doc" />
                              <span>{_lp("Version PDF")}</span>{" "}
                              <i className="icn-glass" />
                            </a>
                          </li>
                          {this.props.price_pack === 1 && (
                            <li className="cr-word">
                              <a
                                title=""
                                href="#"
                                onClick={this.toggleTheModel}
                              >
                                <i className="icn-word ic-doc" />
                                <span>{_lp("Version Word")}</span>{" "}
                                <i className="icn-glass" />
                              </a>
                            </li>
                          )}
                          <li className="cr-annexes">
                            <span>{_lp("Annexes")}</span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-sm-6">
                        <h4>
                          {_lp("Pourquoi nos documents sont-ils fiables ?")}
                        </h4>
                        <p>
                          {_lp("Ces documents sont ")}
                          <strong>
                            {_lp(
                              "à jour des dernières lois, rédigés par des avocats expérimentés"
                            )}
                          </strong>
                          {_lp(" et adaptés à votre situation.")}
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {this.props.disable_invoice && <LpInvoice />}
              <section
                className="page-section hidden-xs hidden-sm"
                id="pack-checkout"
              >
                {this.props.seconde_cta && (
                  <a
                    className="btn btn-block btn-primary cta-payement"
                    href="#"
                    onClick={() => {
                      lpApp.ops.checkout.showCreditCardModal();
                    }}
                  >
                    <span className="loading-spin" />
                    <i className="icn-lock" />
                    <span className="btn-text">
                      {typeof customCheckoutCta === "string" &&
                      customCheckoutCta.trim().length > 0
                        ? customCheckoutCta
                        : _lp("Payer et Télécharger")}
                    </span>
                  </a>
                )}
              </section>

            {lpApp.contractMetaId === 302 ?  (
              null
            ) : <LpMobilePayBar />}
            </div>
            {lpApp.contractMetaId === 302 ?  (
              null
            ) : <LpCart />}
            {<PreviewModal />}
          </div>
        )}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  doc_state: state.document_state.unique,
  mail: state.account_settings.mail,
  price_pack: state.checkout_operations.pack,
  title: state.contract.name,
  choosenPack: state.checkout_operations.pack,
  togglepack: state.checkout_operations.togglepack,
  seconde_cta: lpApp.references.customs.custom
  && lpApp.references.customs.custom.disablesecondpaymentcta
    ? !lpApp.references.customs.custom.disablesecondpaymentcta
    : true,
  pack_content: lpApp.references.customs.custom
  && lpApp.references.customs.custom.disablepackcontent
    ? !lpApp.references.customs.custom.disablepackcontent
    : true,
  disable_options: lpApp.references.customs.custom
  && lpApp.references.customs.custom.disableoptions
    ? !lpApp.references.customs.custom.disableoptions
    : true,
  disable_invoice: lpApp.references.customs.custom
  && lpApp.references.customs.custom.disableinvoice
    ? !lpApp.references.customs.custom.disableinvoice
    : true,
});


const mapDispatchToProps = dispatch => ({
  setContinue: () => {
    // dispatch({type: SET_DOCUMENT_ID, doc: d})
  },
  showTheModal: () => {
    dispatch(togglePreview());
  },
});

const LpPacks = connect(mapStateToProps, mapDispatchToProps)(_Packs);

export default LpPacks;



// WEBPACK FOOTER //
// ./src/components/buy/packs.js